import * as z from 'zod/v4';

export const groupIdSchema = z.number(); // TODO: branded type?
